import styled, { css } from "styled-components";
import { Flex } from "../Flex";
import { getPropertyByMedia, getThemeTokenParser } from "../helpers";
export const ExternalIconWrapper = styled(Flex).attrs(() => ({ as: "i" })) `
	flex-shrink: 0;
	user-select: none;

	* {
		flex-shrink: 0;

		${({ color }) => getPropertyByMedia("color", getThemeTokenParser(color, "colors"))};
		${({ color }) => getPropertyByMedia("fill", getThemeTokenParser(color, "colors"))};

		${({ size }) => getPropertyByMedia("font-size", size)};
		${({ size, sizeIgnoreHeight }) => !sizeIgnoreHeight && getPropertyByMedia("height", size)};
		${({ size }) => getPropertyByMedia("width", size)};
	}
`;
export const SymbolsWrapper = styled(Flex).attrs(() => ({ as: "i" })) `
	user-select: none;

	${({ color }) => getPropertyByMedia("color", getThemeTokenParser(color, "colors"))};
	${({ size }) => getPropertyByMedia("font-size", size)};

	${({ materialSymbols }) => {
    const { fill, grade, opticalSize, weight } = materialSymbols;
    return css `
			font-variation-settings: 'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opticalSize};
		`;
}}
`;
export const InvisibleIconRotatorWrapper = styled.div `
	@keyframes iconRotationOn {
		0% {
			transform: rotateZ(0deg);
		}

		100% {
			transform: rotateZ(180deg);
		}
	}

	@keyframes iconRotationOff {
		0% {
			transform: rotateZ(180deg);
		}

		100% {
			transform: rotateZ(0deg);
		}
	}

	* svg,
	i {
		animation: ${({ rotate }) => (rotate ? "iconRotationOn" : "iconRotationOff")} 0.5s forwards;
	}
`;
export const CustomIconComponent = styled.div `
	${({ size }) => getPropertyByMedia("max-width", size, "16px")};
	${({ size, sizeIgnoreHeight }) => !sizeIgnoreHeight && getPropertyByMedia("max-height", size, "16px")};

	* {
		${({ color }) => getPropertyByMedia("color", color)};
		${({ color }) => getPropertyByMedia("fill", color)};
	}
`;
//# sourceMappingURL=styles.js.map